import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var __jsx = React.createElement;
import React from "react";
import stl from "@/_MiniApps/Tamweel/TamweelForm.module.css";
import { useSearchParams } from "react-router-dom";
import useHelpers from "@hooks/useHelpers";
import { useTranslation } from "@i18n";
import { useAribFinance } from "@/common/Contexts/AribFinanceContext";
import useWebView from "@hooks/useWebview";
var SemaNotEligible = function SemaNotEligible(_ref) {
  var customTitle = _ref.customTitle,
    customText = _ref.customText,
    _ref$backToForm = _ref.backToForm,
    backToForm = _ref$backToForm === void 0 ? false : _ref$backToForm,
    _ref$hideBacToHome = _ref.hideBacToHome,
    hideBacToHome = _ref$hideBacToHome === void 0 ? false : _ref$hideBacToHome,
    _ref$contTopUpload = _ref.contTopUpload,
    contTopUpload = _ref$contTopUpload === void 0 ? false : _ref$contTopUpload,
    _ref$backToTrack = _ref.backToTrack,
    backToTrack = _ref$backToTrack === void 0 ? false : _ref$backToTrack;
  var post_id = useAribFinance().queryParams.post_id;
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var _useHelpers2 = useHelpers(),
    navigateTo = _useHelpers2.navigateTo;
  var _useTranslation = useTranslation(["web_checkout_finance"]),
    t = _useTranslation.t;
  var webview = useWebView();
  return /*#__PURE__*/React.createElement("div", {
    className: ["container", stl.container].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: [stl.form, stl.rejection].join(" ")
  }, /*#__PURE__*/React.createElement("i", {
    className: stl.ErrIcon
  }), /*#__PURE__*/React.createElement("h3", {
    className: stl.h3Tag
  }, customTitle), customText && /*#__PURE__*/React.createElement("p", {
    className: stl.pStyle
  }, customText), contTopUpload && /*#__PURE__*/React.createElement("button", {
    className: [stl.btn, "blueBtn"].join(" "),
    onClick: function onClick() {
      return navigateTo("/finance-apply-arib", {
        post_id: post_id,
        financestep: 5
      });
    }
  }, t("continue_application", {
    ns: "web_checkout_finance"
  })), !contTopUpload && backToForm && /*#__PURE__*/React.createElement("button", {
    className: [stl.btn, "blueBtn"].join(" "),
    onClick: function onClick() {
      return navigateTo("/finance-apply-arib", {
        post_id: post_id,
        financestep: 1
      });
    }
  }, t("return_form", {
    ns: "web_checkout_finance"
  })), !contTopUpload && backToTrack && /*#__PURE__*/React.createElement("button", {
    className: [stl.btn, "blueBtn"].join(" "),
    onClick: function onClick() {
      return navigateTo("/tracking-landing");
    }
  }, t("track_car_order", {
    ns: "web_checkout_finance"
  })), !contTopUpload && /*#__PURE__*/React.createElement("div", {
    className: [stl.btn, !hideBacToHome && !backToForm && !backToTrack ? "blueBtn" : "whtBtn"].join(" "),
    onClick: function onClick() {
      webview.openScreen("post_details", {
        post_id: post_id
      })["catch"](function () {
        navigateTo("/cardetail/" + post_id);
      });
    }
  }, t("back_car_details", {
    ns: "web_checkout_finance"
  })), !contTopUpload && !backToForm && !hideBacToHome && !backToTrack && /*#__PURE__*/React.createElement("a", {
    className: [stl.btn, "whtBtn"].join(" "),
    href: createUrl("/")
  }, t("back_homepge", {
    ns: "web_checkout_finance"
  }))));
};
export default SemaNotEligible;